<button class="btn btn-sm btn-primary dropdown-toggle w-auto" type="button" data-bs-toggle="dropdown"
    aria-expanded="false" translate="Button.NewRequest">
</button>
<div class="dropdown">
    <ul class="dropdown-menu w-auto">
        <li class="dropdown-header" translate="WorkFlowRequests.NewRequestTypeHeaders.Generic"
            *ngIf="workflowsOfTypeGeneric.length > 0 "></li>
        <li *ngFor="let genericWorkflow of workflowsOfTypeGeneric">
            <a class="dropdown-item" (click)="openNewRequest(genericWorkflow.id)"
                [translate]="genericWorkflow.translationKey">
            </a>
        </li>
        <ng-container *ngIf="allowAllRequestsTypes">
            <li class="pt-4 dropdown-header" translate="WorkFlowRequests.NewRequestTypeHeaders.Tax"
                *ngIf="workflowsOfTypeTax.length > 0 ">
            </li>
            <li *ngFor="let taxWorkflow of workflowsOfTypeTax">
                <a class="dropdown-item" (click)="openNewRequest(taxWorkflow.id)"
                    [translate]="taxWorkflow.translationKey">
                </a>
            </li>
            <li class="pt-4 dropdown-header" translate="WorkFlowRequests.NewRequestTypeHeaders.CoC"
                *ngIf="workflowsOfTypeChamberOfCommerce.length > 0 "></li>
            <li *ngFor="let cocWorkflow of workflowsOfTypeChamberOfCommerce">
                <a class="dropdown-item" (click)="openNewRequest(cocWorkflow.id)"
                    [translate]="cocWorkflow.translationKey">
                </a>
            </li>
            <li class="pt-4 dropdown-header" translate="WorkFlowRequests.NewRequestTypeHeaders.Sbr"
                *ngIf="workflowsOfTypeSbrNexus.length > 0 "></li>
            <li *ngFor="let sbrNexusWorkflow of workflowsOfTypeSbrNexus">
                <a class="dropdown-item" (click)="openNewRequest(sbrNexusWorkflow.id)"
                    [translate]="sbrNexusWorkflow.translationKey">
                </a>
            </li>
            <li class="pt-4 dropdown-header" translate="WorkFlowRequests.NewRequestTypeHeaders.Wwft"
                *ngIf="workflowsOfTypeWwft.length > 0 "></li>
            <li *ngFor="let WwftWorkflow of workflowsOfTypeWwft">
                <a class="dropdown-item" (click)="openNewRequest(WwftWorkflow.id)"
                    [translate]="WwftWorkflow.translationKey">
                </a>
            </li>
        </ng-container>
    </ul>
</div>